// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__16hK7","contained":"OpenButton_contained__2joLO","disabled":"OpenButton_disabled__VzKJY","error":"OpenButton_error__2ncww"};